import { Localizer } from "../../../infrastructure/localization/localizer";
import { TooltipToken } from "../../../core/components/tokens/TooltipToken";
import { almenMedicinNiveauTokenRegex } from "./const/regex";

type NiveauForklaring = {
    helhed: string;
    teknisk: string;
};

function getNiveauForklaring(niveau: string): NiveauForklaring {
    const baseNiveau = niveau.trim().toUpperCase().replace("*", "");

    switch (baseNiveau) {
        case "A":
            return {
                helhed: Localizer.almenMedicin_kompetenceniveau_A_helhed(),
                teknisk: Localizer.almenMedicin_kompetenceniveau_A_teknisk(),
            };
        case "B":
            return {
                helhed: Localizer.almenMedicin_kompetenceniveau_B_helhed(),
                teknisk: Localizer.almenMedicin_kompetenceniveau_B_teknisk(),
            };
        case "C":
            return {
                helhed: Localizer.almenMedicin_kompetenceniveau_C_helhed(),
                teknisk: Localizer.almenMedicin_kompetenceniveau_C_teknisk(),
            };
        case "D":
            return {
                helhed: Localizer.almenMedicin_kompetenceniveau_D_helhed(),
                teknisk: Localizer.almenMedicin_kompetenceniveau_D_teknisk(),
            };
        default:
            return {
                helhed: Localizer.almenMedicin_kompetenceniveau_E_helhed(),
                teknisk: Localizer.almenMedicin_kompetenceniveau_E_teknisk(),
            };
    }
}

function isStarNiveau(niveau: string): boolean {
    return niveau.trim().toUpperCase().endsWith("*");
}

function buildAlmenMedicinNiveauToken(niveau: string) {
    const forklaring = getNiveauForklaring(niveau);
    const niveauUpper = niveau.trim().toUpperCase();
    const isStar = isStarNiveau(niveauUpper);

    const helhedLabel = Localizer.almenMedicin_kompetenceniveauHelhedsvurdering();
    const tekniskLabel = Localizer.almenMedicin_kompetenceniveauTekniskeFaerdigheder();
    const commonFooter = `<div class="margin-top-s"><i class="tooltip-token-footer-text">${Localizer.almenMedicin_kompetenceniveauFooter()}</i></div>`;

    const starInfo = isStar
        ? `<div class="margin-bottom-xs text-center"><i>${Localizer.almenMedicin_kompetenceniveauGaelderHeleKompetencen()}</i></div>`
        : "";

    const tooltipHtmlBody =
        `<div class="text-left">` +
            starInfo +
            `<div><div><b>${helhedLabel}:</b></div>${forklaring.helhed}</div>` +
            `<div class="margin-top-xs"><div><b>${tekniskLabel}:</b></div>${forklaring.teknisk}</div>` +
            commonFooter +
        `</div>`;

    return {
        label: `[${niveauUpper}]`,
        tooltipHeader: isStar
            ? Localizer.almenMedicin_kompetenceniveauStarTooltipHeader(niveauUpper)
            : `${Localizer.almenMedicin_kompetenceniveauTitel()} ${niveauUpper}`,
        tooltipHtmlBody,
    };
}

type AlmenMedicinNiveauTokenProps = {
    text?: string;
    className?: string;
    enabled?: boolean;
};

export function AlmenMedicinNiveauToken({ text, className, enabled = true }: AlmenMedicinNiveauTokenProps) {
    return (
        <TooltipToken
            text={text}
            tokenRegex={almenMedicinNiveauTokenRegex}
            className={className}
            enabled={enabled}
            buildToken={buildAlmenMedicinNiveauToken}
        />
    );
}
